function range(startAt = 0, size, step = 1) {
    let numbers = [];
    for(let i = startAt; i < size; i += step){
        numbers.push(i);
    }
    return numbers;
}

function hour_to_Min(hour){
    let split = hour.split(":");
    return parseInt(split[0]) * 60 + parseInt(split[1]);
}

function min_to_Hour(minutes){
    let hourText = Math.floor(minutes / 60);
    let minutesText = (minutes % 60);

    if (hourText < 10)
        hourText = "0" + hourText;

    if (minutesText < 10)
        minutesText = "0" + minutesText;

    return hourText + ":" + minutesText;
}

function get_actual_day(day){
    if(day == 0) return 7;
    return day;
}

export default {
    hour_to_Min: hour_to_Min,
    range:range,
    min_to_Hour:min_to_Hour
}


// WEBPACK FOOTER //
// ./src/date.js